/**
 * @generated SignedSource<<5aec58951019aec6c10f55d293aa435d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleFurtherReadingWidgetArticle$data = {
  readonly entityId: string;
  readonly moreOnThisArticles: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"articleWidgetContent">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "articleFurtherReadingWidgetArticle";
};
export type articleFurtherReadingWidgetArticle$key = {
  readonly " $data"?: articleFurtherReadingWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleFurtherReadingWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleFurtherReadingWidgetArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "moreOnThisArticles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "articleWidgetContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "3cbd439d7f892769e2760cc2c6fbe4ce";

export default node;
